"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var FreeShippingThresholdProgressBar = function (_a) {
    var cartTotal = _a.cartTotal, threshold = _a.threshold;
    var barWidthPercentage = cartTotal >= threshold ? 100 : (cartTotal / threshold) * 100.0;
    return ((0, preact_1.h)("div", { class: "cart-section__review-threshold-bar-container" },
        (0, preact_1.h)("div", { class: "cart-section__review-threshold-bar", style: { width: "".concat(barWidthPercentage, "%") } })));
};
exports.default = FreeShippingThresholdProgressBar;
